module.exports = __webpack_public_path__ + "img/local_road.c939d15b.svg";